import { render, staticRenderFns } from "./article-proven.vue?vue&type=template&id=dfcb45f4"
import script from "./article-proven.vue?vue&type=script&lang=js"
export * from "./article-proven.vue?vue&type=script&lang=js"
import style0 from "./article-proven.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports